





















import {
    defineComponent,
    Ref,
    ref,
} from '@vue/composition-api';
import { ScanOperation } from '@/type/enums';
import { cancelQrLogin } from '@ks/sso';
import {
    getQrcode,
    scanResult,
    acceptResult,
    getAppSecret,
} from '@/apis/controll';

export default defineComponent({
    props: {
        appId: {
            type: String,
            required: true,
        },
    },
    setup(props, context) {
        const inputType: Ref<string> = ref('password');
        const appSecret: Ref<string> = ref('0000000000000000000000');
        const qrCodeInfo: Ref<Record<string, any>> = ref({});
        const timer: Ref<number> = ref(-1);

        async function getSelfAppSecret(oauthtoken: string, cb: Function) {
            try {
                const res = await getAppSecret(props.appId, oauthtoken);
                if (res.data.result === 1) {
                    appSecret.value = res.data.secret;
                    cb && cb();
                } else {
                    context.root.$message.error(
                        res.data.desc || '出错了，请重试',
                    );
                }
            } catch (e) {
                context.root.$message.error('服务器错误');
            }
        }

        async function toggleType() {
            if (inputType.value === 'password') {
                // eslint-disable-next-line no-use-before-define
                const oauthtoken = await scanForoAuthToken(props.appId);

                if (oauthtoken === 'cancel') {
                    //
                } else if (typeof oauthtoken === 'string') {
                    await getSelfAppSecret(oauthtoken, () => {
                        timer.value = window.setTimeout(() => {
                            clearTimeout(timer.value);
                            inputType.value = 'password';
                        }, 5 * 60 * 1000);
                        inputType.value = 'text';
                    });
                }
            } else {
                clearTimeout(timer.value);
                inputType.value = 'password';
            }
        }

        async function getSelfQrcode(appId: string) {
            try {
                const qrStart = await getQrcode('oauth-secure-confirm', {
                    app_id: appId,
                    operation: ScanOperation.view,
                });

                qrCodeInfo.value = qrStart;

            } catch (e) {
                context.root.$message.error('服务器错误');
            }
        }

        async function scanForoAuthToken(
            appid: string,
        ): Promise<string | void>{
            try {
                await getSelfQrcode(appid);
                context.root.$qrCode.show({
                    title: '身份确认',
                    tips: '请使用管理员的快手账号扫码确认该操作',
                    url: `data:image/png;base64,${qrCodeInfo.value.imageData}`,
                    cancelCb() {},
                });
                const qrScan = await scanResult(
                    qrCodeInfo.value.qrLoginToken,
                    qrCodeInfo.value.qrLoginSignature!,
                );

                const oauthtoken = await acceptResult(
                    qrCodeInfo.value.qrLoginToken,
                    qrScan.qrLoginSignature || qrCodeInfo.value.qrLoginSignature,
                );
                context.root.$qrCode.hide();
                cancelQrLogin();
                return oauthtoken.serviceOwnToken || '';
            } catch (e) {
                // return '';
            }
        }
        return {
            inputType,
            appSecret,
            toggleType,
        };
    },
});
